import React, { useEffect, memo, useState } from "react";
import PropTypes from 'prop-types';
import Pagination from "../ui/pagination/Pagination";
import axios from "axios";
import classes from "./VideoPlayerPaged.css";

const dominio = process.env.REACT_APP_DOMINIO;

function VideoPlayerPaged(props) {
  let [videos, setVideos] = useState([]);
  let [selectedVideoId, setSelectedVideoId] = useState(props.defaultVideoId);
  let [videoActivePage, setVideoActivePage] = useState(0);
  let [videosPaged, setVideosPaged] = useState([]);

  //once at startup
  useEffect(() => {
    let youtubeETFs = `${dominio}/biva-channel/videos?q=${props.videoKeyword}&maxResults=50`;
    axios
      .get(youtubeETFs)
      .then(response => {
        setVideos(response.data.items);
      })
      .catch(err => console.error(err.message));
  }, []);

  //on videos changed
  useEffect(() => {
    if (videos.length > 0) {
      setSelectedVideoId(videos[0].id.videoId);
      setVideosPaged(getVideoItemsOnPage(1));
    }
  }, [videos]);

  let getVideoItemsOnPage = (page) => {
    let index_final = page * props.videosPerPage;
    let index_inicial = index_final - props.videosPerPage;
    let slicedItems = videos.slice(index_inicial, index_final);
    return slicedItems;
  }

  let handlePageChange = (pageNumber) => {
    if (pageNumber !== videoActivePage) {
      setVideosPaged(getVideoItemsOnPage(pageNumber));
      setVideoActivePage(pageNumber);
    }
  };

  return (
    <div>
      <div className="width_cien" id="video">
        <iframe
          width="100%"
          height="415"
          src={"https://www.youtube.com/embed/" + selectedVideoId + "?rel=0"}
          frameBorder="0"
          title="videos"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        />
      </div>
      <div className="width_cien">
        <div className={["row relativo", classes.fondo].join(" ")}>
          {videosPaged.map(video => {
            return (
              <div className={["col-4", classes.containerDiv].join(" ")}
                onClick={() => setSelectedVideoId(video.id.videoId)} key={video.id.videoId}>
                <div className={["row"].join(" ")}>
                  <div className={["sin_padding col-12", classes.thumbanil].join(" ")}>
                    <img src={video.snippet.thumbnails.medium.url} alt="" />
                  </div>
                  <div className={["sin_padding col-12"].join(" ")}>
                    <span className={[classes.titulo_video, "color_azul"].join(" ")}>
                      {video.snippet.title}
                    </span>
                  </div>
                </div>
              </div>
            )
          })}
          <div className={"col-12 sin_padding"}>
            <Pagination
              claseTipo={2}
              numRows={videos.length}
              paginas={5}
              itemsPerPage={props.videosPerPage}
              handlePageChange={(e) => handlePageChange(e)}
              activePage={videoActivePage}
            />
          </div>
        </div>
      </div>
    </div>
  );

}

VideoPlayerPaged.propTypes = {
  videosPerPage: PropTypes.number,
  defaultVideoId: PropTypes.string,
  videoKeyword: PropTypes.string,
}

VideoPlayerPaged.defaultProps = {
  videosPerPage: 5,
  defaultVideoId: "Lij7oUkiZuY",
  videoKeyword: "BIVA",
}

export default memo(VideoPlayerPaged);
